export default __webpack_public_path__ + "images/c4e80c3695332041585d42ac4def9b61.png";